module.exports = __webpack_public_path__ + "img/ad-ys.09fef6d7.png";